import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ICmsCoreModule } from '@icms/core/icms-core.module';
import { ICmsUiModule } from '@icms/ui/icms-ui.module';
import { ICmsShortcutsComponent } from './icms-shortcuts.component';
import { ICmsShortcutsProvider } from './icms-shortcuts.provider';
import { ICmsShortcutsService } from './icms-shortcuts.service';
import { ICmsShortcutsSearchComponent } from './search/icms-shortcuts-search.component';

@NgModule({
    imports: [CommonModule, FormsModule, ICmsUiModule, ICmsCoreModule, RouterModule],
    providers: [ICmsShortcutsProvider, ICmsShortcutsService],
    declarations: [ICmsShortcutsComponent, ICmsShortcutsSearchComponent]
})
export class ICmsShortcutsModule {
    constructor(iCmsShortcutsService: ICmsShortcutsService, injector: Injector) {
        iCmsShortcutsService.registerInjector(injector);
    }
}
